<template>
	<div v-if="showPage">
		<div style="padding-bottom: 1rem;">
			<div class="info-title">
				<span class="fl title-info ellipsis">{{scalar.name}}</span>
				<div class="start-test fr toquestion">
					<span class="icon icon-paishe">&#xe6a0;</span>
					<span @click="toquestion()" v-if="!isAnswer">立即测评</span>
          <span @click="toresult()" v-if="isAnswer">查看报告</span>
				</div>
			</div>
			<div class="cover-box">
				<img v-bind:src="scalar.photo" style="width: 100%;"/>
			</div>
			<div class="scale-desc-box">
				<div class="scale-desc clearfix plr15">
					<div class="scale-desc-left fl" style="width: auto;">
						<div class="scale-name relative">
							<p class="border"></p>{{scalar.name}}简介
						</div>
						<p class="scale-miaoshu">{{scalar.introduction}}</p>

					</div>
				</div>
			</div>
			<div class="test-desc">
				<div class="test-shuoming relative">
					答题说明
					<p class="border" style="top: 0.08rem;"></p>
				</div>
				<p class="desc-info">{{scalar.answer_note}}</p>

			</div>
			<div class="scale-desc-box" v-if="!(id==56 || id==57 || id==58)">
				<div class="scale-desc clearfix plr15" style="border: none;">
					<div class="scale-desc-left fl" style="width: auto;">
						<div class="scale-name relative">报告亮点
							<p class="border"></p>
						</div>
						<p class="scale-miaoshu">{{scalar.report_note}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="model" v-if="showModel">
			<div class="model-box" v-if="modelType=='test'">
				<div class="relative">
					<p class="absolute icon icon-chahao" @click="hideModel()">&#xe603;</p>
					<img src="../assets/model.png" style="margin-bottom: 0.6rem;"/>
					<p class="model-text">有上次未完成的测评</p>
					<p class="model-text">是否继续</p>
					<div class="model-btn-box" style="margin-top: 1.4rem;">
						<p class="model-btn agin" @click="nextquestion()">继续测评</p>
						<p class="model-btn repeat" @click="toquestion()">重新测评</p>
					</div>
				</div>
			</div>
			<div class="model-box" v-if="modelType=='child'">
				<div class="relative">
					<p class="absolute icon icon-chahao"  @click="hideModel()">&#xe603;</p>
					<img src="../assets/model.png" style="margin-bottom: 0.6rem;"/>
					<p class="model-text">为确保测评准确</p>
					<p class="model-text">请先添加宝宝信息</p>
					<div class="model-btn-box" style="display:flex;justify-content:center;margin-top:1rem;">
						<p class="model-btn agin" style="width: 2.74rem;" @click="touserinfo()">添加宝宝信息</p>
					</div>
				</div>
			</div>
		</div>
		<bottomBar :bottom="bottom"></bottomBar>
	</div>
</template>

<script>
	import bottomBar from '../components/bottomBar.vue'
	export default {
		data() {
			return {
				bottom: 0,
				scalar:'',
				id:'',//量表id
				showPage:false,
				showModel:true,
				modelType:'child',//test child
				user:'',
				insituation:'',
				showBottom:false,
				number:'',
        link:'',
        isAnswer:false
			}
		},
		created: function() {
			this.showModel = false;
			this.id=searchParam('id');
			if(localStorage.getItem('user')!=null && localStorage.getItem('user')!=undefined){
				this.user = JSON.parse(localStorage.getItem('user'));
			}
			if(this.id==null){
				this.id = this.$route.params.id;
			}
			if(this.id==undefined){
				this.id = sessionStorage.getItem('id');
			}
			this.insituation = searchParam('insituation');
			if(this.insituation!=null){
				sessionStorage.setItem('insituation',this.insituation);
			}else{
				this.insituation = sessionStorage.getItem('insituation');
			}
			this.scalarInfo();
			this.loadUser();
		},
		methods: {
			toresult(){
        // alert(toResult+this.link+'?number='+this.number+"&userid="+this.user.openid+"&openid="+this.user.children.data[0].openid);
        window.location.href = 'http://report.jingyunzhixin.com/'+this.link+'?number='+this.number+"&userid="+this.user.openid+"&openid="+this.user.children.data[0].openid;
			},
			scalarInfo:function(){
				var that = this;
				if(this.user==''){
					var url = 'institutions/'+this.insituation+'/scalars/'+this.id+'/users';
				}else{
          // console.log();
          if(this.user.children.data.length>0){
            var url = 'institutions/'+this.insituation+'/scalars/'+this.id+'/users/'+this.user.children.data[0].openid
          }else{
            var url = 'institutions/'+this.insituation+'/scalars/'+this.id+'/users/'+this.user.openid
          }

				}
				http.get(url).then(function(res){
          if(res.data.data.assess.data.length!=0 && res.data.data.assess.data[0].status==5){
            that.isAnswer = true;
            that.number = res.data.data.assess.data[0].number;
            that.link = res.data.data.link;
          }
					var time = getTime(new Date().getTime()).timeDay;
					if(res.data.data.institution.data[0].expired_at!=null && res.data.data.institution.data[0].expired_at<time){
						that.$router.push({name:'delay'});
					}
					that.scalar = res.data.data;
					sessionStorage.setItem('note',that.scalar.introduction);
					sessionStorage.setItem('link',that.scalar.link);
					that.scalar.photo = photoUrl + that.scalar.picture.data[0].cover;
					that.showPage = true;
					document.title = that.scalar.name;
				})
			},
			hideModel:function(){
				this.showModel = false;
			},
			toquestion:function(){

				if(localStorage.getItem('user')==null || localStorage.getItem('user')==undefined){
					this.$router.push({name:'login'});
					return;
				}
        if(this.id==93){
          this.parentQuestion();
        }else{
          if(this.user.children.data.length==0){
          	this.showModel = true;
          	this.modelType = 'child';
          }else{
          	if(this.user.children.data.length!=0){//有宝宝信息
          		this.createQuestion();
          		//跳转答题页面
          	}else{
          		this.showModel = true;
          		this.modelType = 'child';
          	}
          }
        }
			},

			nextquestion:function(){
				var that = this;
				if(this.id==56 || this.id == 57 || this.id==58){
					that.$router.push({name:'question',params:{number:this.number,isdiaoyan:1}})
				}else{
					that.$router.push({name:'question',params:{number:this.number}})
				}

			},
			touserinfo:function(){
				this.$router.push({name:'userinfo'});
			},
			loadUser:function(){
				if(localStorage.getItem('user')){
					var openid = JSON.parse(localStorage.getItem('user')).openid;
					var that = this;
					var url = 'institutions/'+this.insituation+'/users/'+openid;
					http.get(url).then(function(res){
//						localStorage.setItem('user',JSON.stringify(res.data.data));
//						loadShare(res.data.data.name+'的家庭调研', '了解家庭中的人格与养育，增加包容与支持的生活智慧', '11',location.href.split('#')[0]+'#/scalarlist?insituation='+that.insituation+'&openid='+openid);
					}).catch(function(res){
						localStorage.removeItem('user');
					})
				}
			},
      parentQuestion(){
        var that = this;
        http.post('institutions/'+this.insituation+'/assesses?user_id='+this.user.openid+'&scalar_id='+this.id).then(function(res){
        	that.$router.push({name:'question',params:{number:res.data.data.number,isdiaoyan:1}})
        }).catch(function(res){
        	alert1('年龄不符，换个其它量表试试吧');
        })
      },
			createQuestion:function(){
				var that = this;
				http.post('institutions/'+this.insituation+'/assesses?openid='+this.user.children.data[0].openid+'&user_id='+this.user.openid+'&scalar_id='+this.id).then(function(res){
					if(that.user.children.data.length==1){
						that.$router.push({name:'question',params:{number:res.data.data.number}})
					}else{
						that.$router.push({
							name:'selectinfomation',
							params:{
								id:that.id
							}
						})
					}
				}).catch(function(res){
					alert1('宝宝的年龄不适合这个测评哦，换个其它量表试试吧');
				})
			}
		},
		components: {
			bottomBar
		},
	}
</script>

<style scoped>
	/* pages/scaleinfo/scaleinfo.wxss */

	.info-title {
		height: 0.80rem;
		padding-left: 0.30rem;
		padding-right: 0.30rem;
		background: rgba(38, 162, 255, 0.3);
		position: fixed;
		top: 0;
		left: 0;
		width: 6.90rem;
	}

	.title-info {
		line-height: 0.80rem;
		font-size: 0.36rem;
		color: #fff;
		display: inline-block;
		width: 4.40rem;
	}

	.search-wrapper {
		height: 0.56rem;
		padding-top: 0.12rem;
		width: 2.00rem;
	}

	.search-box {
		width: 100%;
		height: 100%;
		background: #fff;
		border-radius: 0.50rem;
	}

	.search-btn {
		color: #999;
		line-height: 0.58rem;
		font-size: 0.24rem;
		padding-left: 0.25rem;
	}

	.search-font {
		line-height: 0.56rem;
		font-size: 0.28rem;
		color: #999;
		padding-left: 0.28rem;
		opacity: 0.8;
	}

	.test-operate {
		height: 1.32rem;
		/* border-bottom: 1px solid #FFCCCC; */
	}

	.children-list {
		display: inline-block;
		width: 1.20rem;
		line-height: 0.60rem;
		font-size: 0.28rem;
		color: #fff;
		border-radius: 0.04rem;
		background: #FFC071;
		text-align: center;
	}

	.start-test {
		width: 2.20rem;
		height: 0.52rem;
		line-height: 0.52rem;
		font-size: 0.32rem;
		color: RGBA(38, 162, 255, 0.8);
		text-align: center;
		border-radius: 0.50rem;
		background: #fff;
		margin-top: 0.14rem;
	}

	.icon-paishe {
		color: RGBA(38, 162, 255, 1)!important;
	}

	.add-children {
		width: 0.60rem;
		height: 0.60rem;
		border-radius: 50%;
		margin-left: 0.20rem;
		margin-top: 0.44rem;
	}

	.charts-box {
		height: 4.28rem;
	}

	.charts {
		height: 100%;
	}

	.test-desc {
		border-top: 1px solid #E8E7E7;
		padding-left: 0.30rem;
		padding-right: 0.30rem;
		padding-top: 0.22rem;
		padding-bottom: 0.52rem;
		background: RGBA(254, 247, 247, 0.8);
		border-bottom: 1px solid #E8E7E7;
	}

	.test-shuoming {
		line-height: 0.40rem;
		font-size: 0.28rem;
		color: RGBA(67, 67, 67, 0.8);
		margin-bottom: 0.16rem;
	}

	.desc-info {
		line-height: 0.32rem;
		font-size: 0.24rem;
		color: RGBA(67, 67, 67, 0.6);
		margin-bottom: 0.08rem;
	}

	.scale-desc {
		padding-top: 0.22rem;
		padding-bottom: 0.22rem;
		border-bottom: 1px solid #eee;
	}

	.scale-desc-left {
		width: 3.20rem;
	}

	.scale-name {
		line-height: 0.40rem;
		padding-top: 0.18rem;
		font-size: 0.28rem;
		color: RGBA(67, 67, 67, 0.8);
		padding-bottom: 0.22rem;
	}

	.scale-miaoshu {
		line-height: 0.32rem;
		font-size: 0.24rem;
		color: RGBA(67, 67, 67, 0.6);
	}

	.scale-img {
		width: 3.44rem;
		height: 2.98rem;
	}

	.model {
		position: fixed;
		height: 100vh;
		width: 100%;
		background: RGBA(0, 0, 0, 0.1);
		top: 0;
		left: 0;
	}

	.model-box {
		margin-top: 2.00rem;
		margin-left: 0.96rem;
		width: 5.60rem;
		height: 6.00rem;
		background: #fff;
		border-radius: 10px;
		overflow: hidden;
	}

	.model-box img {
		width: 100%;
		height: 1.20rem;
		margin-bottom: 0.20rem;
	}

	.model-text {
		padding-top: 0.20rem;
		line-height: 0.60rem;
		color: RGBA(67, 67, 67, 0.8);
		text-align: center;
		padding-left: 0.26rem;
		padding-right: 0.26rem;
		font-size: 0.38rem;
	}

	.model-btn-box {
		margin-top: 0.46rem;
		padding-left: 0.40rem;
		padding-right: 0.40rem;
		display: flex;
		justify-content: space-between;
	}

	.model-btn {
		line-height: 0.60rem;
		text-align: center;
		font-size: 0.28rem;
		color: #fff;

		border-radius: 0.06rem;
		width: 1.78rem;
	}

	.agin {
		background: #F5859D;
	}

	.repeat {
		background: #FFC071;
	}

	.icon-chahao {
		right: 0.12rem;
		top: 0.12rem;
		font-size: 0.36rem;
		color: #fff;
	}

	.cover-box {
		width: 100%;
		height: 4.20rem;
		overflow: hidden;
	}

	.cover-img {
		width: 100%;
		height: 100%;
	}

	.test-operate-box {
		border-top: 1px solid #ccc;
	}

	.border {
		position: absolute;
		height: 0.24rem;
		width: 0.08rem;
		background: #F4869D;
		left: -0.16rem;
		top: 0.24rem;
	}
</style>



// WEBPACK FOOTER //
// src/pages/scalarinfo.vue